import { RouteType } from "types/RouteType";
import { yardManagementRoute } from "@intrasync/yard-management";

/**
 * Routes from `@intrasync/yard-management`.
 *
 * The package owns its route — same pattern as `@intrasync/designer`
 * (`IntraSyncDesignerRoute`) and `@intrasync/accounting` (`accountingHubRoute`).
 * As of 0.0.6 it exports `yardManagementRoute` (a single route object), so we
 * import it directly. The `as unknown as RouteType` cast bridges the package's
 * structurally-compatible route type to the host's `RouteType`.
 */
const yardManagementRoutesList: RouteType[] = [
  yardManagementRoute as unknown as RouteType,
];

export default yardManagementRoutesList;
